import { OnboardingData, UserData, UserState, TotalMetrics, StripeCustomerData } from './types'

export const userInitialState: UserState = {
	onboardingData: {} as OnboardingData,
	userData: {
		status: null,
		data: {},
	} as UserData,
	metrics: {
		status: null,
		data: {},
	} as TotalMetrics,
	stripeCustomerData: {
		status: null,
		data: {
			client_secret: sessionStorage.getItem('stripe_client_secret') || '',
			contact_id: '',
			setup_intent_id: sessionStorage.getItem('stripe_setup_intent_id') || '',
		},
	} as StripeCustomerData,
}
